import React, { useState } from "react";
import { FaTh, FaList } from "react-icons/fa"; // Font Awesome icons

const Switch = ({ onChange, onicon, oficon }) => {
  const [isGrid, setIsGrid] = useState(true);

  const toggleView = () => {
    setIsGrid((prev) => {
      const newState = !prev;
      if (onChange) onChange(newState);
      return newState;
    });
  };
  return (
    <div className="toggle-container" onClick={toggleView}>
      <div className={`slider ${isGrid ? "left" : "right"}`}>
        <div className="icon">
          <FaTh />
        </div>
        <div className="icon">
          <FaList />
        </div>
        <div className="knob">{isGrid ? <FaTh /> : <FaList />}</div>
      </div>
    </div>
  );
};

export default Switch;
